import React from 'react'
import { Router, Route, Redirect, Switch } from 'react-router-dom'
import { AdminLayout } from '../_components/Shared/Layout/AdminLayout'
import { history } from '../_helpers'
import { connect } from 'react-redux'

import SellerForm from '../_components/SellerForm/index';


export const PrivateRoute = ({ component: Component, user, ...rest }) => (
  <Route {...rest} render={props => (
    user && user.token
      ? <AdminLayout><Component {...props} /></AdminLayout>
      : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
  )} />
)


class App extends React.Component {
  render() {
    const { user } = this.props;
    return (
      <Router history={history}>
        <Switch>

          <Route user={user} exact path='/' component={SellerForm} />

        </Switch>
      </Router>

    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App };
